export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    privacyOption: {
      type: Boolean,
      default: true,
    },
    parent: {
      default: false,
    },
  },
  computed: {
    fieldId() {
      return 'field-' + this.field.id
    },
    fieldValueId() {
      return 'field-' + this.field.id + '-' + this.field.value.id
    },
    shouldShowLabel() {
      if (!this.parent) {
        console.log('NO PARENT')
        return true
      }
      if (!_.has(this.parent.attributes.options, 'group')) {
        console.log('NO OPTION SET')
        return true
      }
      return !this.parent.attributes.options.group
    },
  },
}
